import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { db, storage } from '../firebase';
import { collection, addDoc, onSnapshot, serverTimestamp, orderBy, query, where, doc, updateDoc, getDoc, getDocs, limit, deleteDoc,setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Box, TextField, Button, Container, Typography, Paper, Avatar, IconButton, CircularProgress, Alert, AlertTitle, Modal, Badge, AppBar, Toolbar,Drawer, List, ListItem, ListItemIcon, ListItemText, } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import Settings from '@mui/icons-material/Settings'; // Importar el ícono
import axios from 'axios';
import { runTransaction } from 'firebase/firestore';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BarChartIcon from '@mui/icons-material/BarChart';
import MenuIcon from '@mui/icons-material/Menu';
import HistoryIcon from '@mui/icons-material/History';
import PaymentIcon from '@mui/icons-material/Payment';
import { NotificationsNoneSharp } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';

// ---------- Helper: formatea timestamps (Firestore Timestamp, Date, string o number) ----------
function formatTimestamp(ts) {
  try {
    if (!ts) return '—';

    // Firestore Timestamp (has toDate or seconds)
    if (typeof ts?.toDate === 'function') {
      const d = ts.toDate();
      return formatDateForDisplay(d);
    }
    if (ts.seconds !== undefined && ts.nanoseconds !== undefined) {
      // legacy Firestore object
      const d = new Date(ts.seconds * 1000 + Math.round(ts.nanoseconds / 1000000));
      return formatDateForDisplay(d);
    }

    // JS Date
    if (ts instanceof Date) return formatDateForDisplay(ts);

    // number (ms since epoch) or numeric string
    const maybeNum = Number(ts);
    if (!Number.isNaN(maybeNum)) {
      const d = new Date(maybeNum);
      if (!Number.isNaN(d.getTime())) return formatDateForDisplay(d);
    }

    // fallback: try parse as date string
    const parsed = new Date(ts);
    if (!Number.isNaN(parsed.getTime())) return formatDateForDisplay(parsed);

    return String(ts);
  } catch (err) {
    console.warn('formatTimestamp error:', err, ts);
    return '—';
  }
}

function formatDateForDisplay(date) {
  const today = new Date();
  const isToday =
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();

  // si es hoy, mostramos hora corta; si no, fecha + hora corta
  const time = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  if (isToday) return time;
  const datePart = date.toLocaleDateString('es-ES');
  return `${datePart} ${time}`;
}


function Chat() {
  
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [dailyMessageCount, setDailyMessageCount] = useState(0);
  const [isChatDisabled, setIsChatDisabled] = useState(false);
  const [role, setRole] = useState('normal'); 
  const [randomNumbers, setRandomNumbers] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [isSendingAudio, setIsSendingAudio] = useState(false);
  const [showInfoMessage, setShowInfoMessage] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [hasNewPrediction, setHasNewPrediction] = useState(false);
  const [usersWithPredictions, setUsersWithPredictions] = useState([]); // Usuarios que publicaron predicciones
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const audioRef = useRef(null);
  const [hasNewRecharge, setHasNewRecharge] = useState(false);
  const audioNotificationRef = useRef(null);
const [coinMessage, setCoinMessage] = useState('');
const [userCoins, setUserCoins] = useState(0);

  const username = localStorage.getItem('username');
  const avatarUrl = localStorage.getItem('avatarUrl');
const inputRef = useRef();

function getDominicanDate() {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const dominicanOffset = -4; // GMT-4
  return new Date(utc + 3600000 * dominicanOffset);
}

async function generateAndSaveNumbersIfNeeded() {
  const systemDocRef = doc(db, "system", "dailyNumbers");
  const docSnap = await getDoc(systemDocRef);
  const now = getDominicanDate(); // Hora de RD
  const todayStr = now.toISOString().slice(0, 10);

  // ¿Ya existen números para hoy?
  if (docSnap.exists()) {
    const data = docSnap.data();
    if (data.date === todayStr) {
      // Ya están los números de hoy
      return data.numbers;
    }
  }


const hour = now.getHours();
const minute = now.getMinutes();

if (hour !== 6 || minute !== 0) {
  return null; // Solo se permite generar exactamente a las 6:00 AM RD
}

  // Generar 3 números únicos de dos dígitos
  let nums = [];
  while (nums.length < 3) {
    const n = Math.floor(Math.random() * 100).toString().padStart(2, "0");
    if (!nums.includes(n)) nums.push(n);
  }

  // Guardar en Firestore
  await setDoc(systemDocRef, { numbers: nums, date: todayStr });

  return nums;
}

  const [dailyNumbers, setDailyNumbers] = useState([]);



  useEffect(() => {
  async function fetchOrGenerate() {
    const nums = await generateAndSaveNumbersIfNeeded();
    if (nums) setDailyNumbers(nums);
  }
  fetchOrGenerate();
}, []);



  useEffect(() => {
    // Revisa si ya hay números y la fecha en localStorage
    const data = JSON.parse(localStorage.getItem('dailyNumbersData') || '{}');
    const now = new Date();
    const todayStr = now.toISOString().slice(0, 10); // YYYY-MM-DD

    // Solo generar si:
    // - No hay guardado, o
    // - Es otro día, y ya pasó de las 6AM
    const lastDate = data.date;
    const lastNumbers = data.numbers;
    const isSameDay = lastDate === todayStr;

    if (!isSameDay && now.getHours() >= 6) {
      // Genera 3 números únicos de dos dígitos
      let nums = [];
      while (nums.length < 3) {
        const n = Math.floor(Math.random() * 100).toString().padStart(2, '0');
        if (!nums.includes(n)) nums.push(n);
      }
      // Guarda en localStorage
      localStorage.setItem('dailyNumbersData', JSON.stringify({ numbers: nums, date: todayStr }));
      setDailyNumbers(nums);
    } else if (isSameDay && lastNumbers) {
      setDailyNumbers(lastNumbers);
    } else if (!lastNumbers && now.getHours() >= 6) {
      // Primer uso del día
      let nums = [];
      while (nums.length < 3) {
        const n = Math.floor(Math.random() * 100).toString().padStart(2, '0');
        if (!nums.includes(n)) nums.push(n);
      }
      localStorage.setItem('dailyNumbersData', JSON.stringify({ numbers: nums, date: todayStr }));
      setDailyNumbers(nums);
    } else {
      // Antes de las 6AM: muestra los del día anterior (si hay)
      if (lastNumbers) setDailyNumbers(lastNumbers);
    }
    }, []);

  
  const simulateRecharge = () => {
    setHasNewRecharge(true);
    if (audioNotificationRef.current) {
      audioNotificationRef.current.play().catch((error) => {
        console.error('Error al reproducir el sonido:', error);
      });
    }
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  useEffect(() => {
  if (inputRef.current) {
    inputRef.current.focus();
  }
}, [isChatDisabled]);

  useEffect(() => {
    const rechargeRef = collection(db, 'recharges');
  
    const unsubscribe = onSnapshot(
      query(rechargeRef, where('username', '==', username)),
      (snapshot) => {
        console.log('Snapshot detectado:', snapshot.docs); // Depura el snapshot completo
  
        snapshot.docChanges().forEach((change) => {
          console.log('Cambio detectado:', change); // Depura los cambios individuales
  
          if (change.type === 'added') {
            const data = change.doc.data();
            console.log('Datos de la recarga recibida:', data); // Verifica los datos recibidos
  
            if (data.monOro) {
              console.log('monOro detectado:', data.monOro); // Verifica si `monOro` está presente
              setHasNewRecharge(true);
  
              // Reproducir el sonido
              if (audioNotificationRef.current) {
                audioNotificationRef.current.play().catch((error) => {
                  console.error('Error al reproducir el sonido:', error);
                });
              }
            }
          }
        });
      },
      (error) => {
        console.error('Error al escuchar recargas:', error);
      }
    );

    return () => unsubscribe(); // Limpiar el listener al desmontar el componente
  }, [username]);

async function updateDailyNumbersIfNeeded(db) {
  const systemDocRef = doc(db, 'system', 'predictions');
  const systemSnap = await getDoc(systemDocRef);
  const now = new Date();
  let lastUpdate = null;
  let numbers = [];

  if (systemSnap.exists()) {
    const data = systemSnap.data();
    numbers = data.numbers || [];
    lastUpdate = data.date ? data.date.toDate?.() || new Date(data.date) : null;
  }

  // Condición: ¿Necesitamos actualizar? (si no existen o han pasado más de 1 día y es después de las 6 AM)
  if (
    !lastUpdate ||
    now.toDateString() !== lastUpdate.toDateString() && now.getHours() >= 6
  ) {
    // Generar 3 números únicos de 2 dígitos
    let newNumbers = [];
    while (newNumbers.length < 3) {
      let n = Math.floor(Math.random() * 100).toString().padStart(2, '0');
      if (!newNumbers.includes(n)) newNumbers.push(n);
    }
    await setDoc(systemDocRef, {
      numbers: newNumbers,
      date: serverTimestamp(),
    });
    return newNumbers;
  }
  return numbers;
}


  useEffect(() => {
    if (role === 'normal') {
      const interval = setInterval(() => {
        setShowModal(true);
      }, 900000); // tiempo que tarda en salir la ventana modal
      return () => clearInterval(interval);
    }
  }, [role]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleWhatsAppShare = () => {
    const message = encodeURIComponent("¡Únete a nuestro chat de Loterías! Aquí está el enlace: https://chatsrd.com/");
    const whatsappUrl = `https://api.whatsapp.com/send?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };



  // Función para extraer el ID de un enlace de YouTube
const getYouTubeId = (url) => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regExp);
  return match ? match[1] : null;
};

// Función para detectar el enlace y devolver la miniatura
const renderYouTubeThumbnail = (text) => {
  if (!text) return null;

  const urlRegExp = /(https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)\/[^\s]+)/gi;
  const urls = text.match(urlRegExp);

  if (urls && urls.length > 0) {
    const videoId = getYouTubeId(urls[0]);
    if (videoId) {
      const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

      return (
        <div
          style={{
            width: "100%",
            maxWidth: "380px",
            marginTop: 8,
            marginBottom: 8,
          }}
        >
          <a href={urls[0]} target="_blank" rel="noopener noreferrer">
            <img
              src={thumbnailUrl}
              alt="YouTube Thumbnail"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                cursor: "pointer",
                display: "block",
              }}
            />
          </a>
        </div>
      );
    }
  }

  return null;
};


  const keywordGroups = [
  {
    words: ['PALE', 'SUPER PALE', 'QUINIELA', 'TRIPLETA', 'BINGO', 'LOTO'],
    style: `
  font-size: 1.5em;
  font-weight: bold;
  font-family: 'Segoe UI', 'Roboto', sans-serif;
  padding: 4px 8px;
  background: linear-gradient(135deg, #f39c12, #e74c3c, #9b59b6);
  color: white;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  display: inline-block;
  transform: skewX(-5deg);
  transition: all 0.2s ease-in-out;
    `
  },
  {
    words: ['00','13','23', '88', '22', '55', '66', '77', '99', '11', '33', '44', '22'],
    style: `
      font-size: 1.3em;
      color: #00b894;
      font-weight: bold;
      font-family: 'Verdana';
      background-color: #dff9fb;
      border-radius: 4px;
      padding: 2px 4px;
    `
  },
  {
    words: ['HOY', 'AHORA', 'RÁPIDO'],
    style: `
      color: #e74c3c;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 1.1em;
    `
  }
];


const highlightKeyword = (text) => {
  let formattedText = text;

  keywordGroups.forEach((group) => {
    const regex = new RegExp(`\\b(${group.words.join('|')})\\b`, 'gi');
    formattedText = formattedText.replace(regex, (match) => {
      return `<strong style="${group.style}">${match}</strong>`;
    });
  });

  return formattedText;
};


  const handleClick = () => {
    navigate('/Subscribe'); // Navegar a la página de Subscribe
  };
  

  useEffect(() => {
    const fetchUserCoins = async () => {
      try {
        const userDocRef = doc(db, 'users', username); // Asegúrate de que 'users' es el nombre correcto de la colección
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log('Datos del usuario:', userData); // Depura para verificar los datos
          setUserCoins(userData.monOro || 0); // Asigna el valor de monOro o 0 si no existe
        } else {
          console.log('El documento del usuario no existe.');
        }
      } catch (error) {
        console.error('Error al obtener las monedas del usuario:', error);
      }
    };
  
    fetchUserCoins();
  }, [username]);


  const filterMessage = (message) => {
    const bannedWords = new Set(['whatsapp', 'ws', '809', '829', '849', 'dame tu contacto', 'gmail.com', 'outlook.com']);
    let containsProfanity = false;

    const filteredMessage = message
      .split(' ')
      .map(word => {
        if (bannedWords.has(word.toLowerCase())) {
          containsProfanity = true;
          return '****';
        }
        return word;
      })
      .join(' ');

    if (containsProfanity) {
      setTimeout(async () => {
        await addDoc(collection(db, 'messages'), {
          text: 'No se permite publicar números de contactos en este chat. Favor de revisar las reglas para evitar que su cuenta se cierre',
          username: '⚠️ !AVISO!',
          avatarUrl: '',
          timestamp: serverTimestamp(),
          role: 'sistema',
        });
      }, 10000);
    }

    return filteredMessage;
  };

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };



  useEffect(() => {
  // Función para publicar el mensaje del sistema
  const publishSystemMessage = async () => {
    try {
      await addDoc(collection(db, 'messages'), {
        text: `🔔 Recarga tu cuenta y apoya a quienes dedican su esfuerzo para compartir sus predicciones. ¡Haz clic aquí y contribuye a su labor! <a href="https://chatsrd.com/coin-history" style="color: #1e88e5; font-weight: bold;">Recargar Cuenta</a>`,
        username: 'Sistema',
        avatarUrl: 'https://firebasestorage.googleapis.com/v0/b/otra-151ec.appspot.com/o/avatars%2Fadministrador?alt=media&token=cd23ca64-8f38-4357-8861-8f1302e19db2',
        timestamp: serverTimestamp(),
        role: 'sistema',
      });
      console.log('Mensaje del sistema publicado.');
    } catch (error) {
      console.error('Error al publicar el mensaje del sistema:', error);
    }
  };

  // Publicar el mensaje cada 48 horas (48 horas = 172800000 milisegundos)
  const interval = setInterval(() => {
    publishSystemMessage();
  }, 172800000);

  // Limpiar el intervalo al desmontar el componente
  return () => clearInterval(interval);
}, []);


  useEffect(() => {
    const userDocRef = doc(db, 'users', username);

    const checkFirstTime = async () => {
      const userDoc = await getDoc(userDocRef);
      if (userDoc.exists() && userDoc.data().firstTime && !userDoc.data().welcomeMessageSent) {
        await addDoc(collection(db, 'messages'), {
          text: `🎉 ¡Hola, <strong>${username}</strong>! 🎉 
          Bienvenido/a al chat por primera vez. 🎊 
          Nos alegra mucho que estés aquí. 
          🌟 ¡Únete a la conversación y sé parte de nuestra comunidad! 🌟`,
          username: 'Sistema',
          avatarUrl: 'https://firebasestorage.googleapis.com/v0/b/otra-151ec.appspot.com/o/avatars%2Fadministrador?alt=media&token=cd23ca64-8f38-4357-8861-8f1302e19db2', // Avatar del sistema
          timestamp: serverTimestamp(),
          role: 'sistema',
          style: {
            backgroundColor: '#e0f7fa', // Azul claro suave
        color: '#00796b', // Verde azulado elegante
        fontWeight: 'bold',
        borderRadius: '12px', // Bordes ligeramente más redondeados
        padding: '12px', // Más espacio interno para mayor claridad
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)', // Sombra más suave y difusa
        textAlign: 'center',
        border: '1px solid #80cbc4', // Borde suave en tono complementario
        fontSize: '1.1rem', // Tamaño de fuente ligeramente aumentado
          },
        });
    
        await updateDoc(userDocRef, {
          firstTime: false,
          welcomeMessageSent: true,
        });
      }
    };


    const fetchAvatarUrl = async () => {
      try {
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const fetchedAvatarUrl = userData.avatarUrl;
          console.log("Fetched Avatar URL:", fetchedAvatarUrl); // Depurar URL obtenida
    
          if (fetchedAvatarUrl) {
            localStorage.setItem('avatarUrl', fetchedAvatarUrl);
          } else {
            localStorage.removeItem('avatarUrl'); // Limpia si no existe
          }
        }
      } catch (error) {
        console.error("Error fetching avatar URL:", error);
      }
    };

    checkFirstTime();
    fetchAvatarUrl();


    
    updateDoc(userDocRef, { online: true });

    const unsubscribeMessages = onSnapshot(
      query(
        collection(db, 'messages'),
        orderBy('timestamp', 'desc'),
        limit(50)
      ),
      (snapshot) => {
        const loadedMessages = snapshot.docs.map(doc => ({ id: doc.id, data: doc.data() }));
        setMessages(loadedMessages.reverse());
        scrollToBottom();
      }
    );

    const unsubscribeUserDoc = onSnapshot(userDocRef, async (docSnap) => {
      if (docSnap.exists()) {
        const userData = docSnap.data();
        const previousRole = role;
        setRole(userData.role || 'normal');

    

        if (userData.role === 'normal') {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const messagesQuery = query(
            collection(db, 'messages'),
            where('username', '==', username),
            where('timestamp', '>=', today)
          );

          const messagesSnapshot = await getDocs(messagesQuery);
          setDailyMessageCount(messagesSnapshot.size);

          if (messagesSnapshot.size >= 50) {
            setIsChatDisabled(true);
          }
        }
      }
    });

    const handleDisconnect = () => {
      updateDoc(userDocRef, {
        online: false,
        lastOnline: serverTimestamp(),
      });
    };

    window.addEventListener('beforeunload', handleDisconnect);

    return () => {
      unsubscribeMessages();
      unsubscribeUserDoc();
      window.removeEventListener('beforeunload', handleDisconnect);
      updateDoc(userDocRef, { online: false });
    };
  }, [username, role, avatarUrl]);

  const sendMessage = async (e) => {
    e.preventDefault();

    if (isChatDisabled) {
      alert("Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.");
      return;
    }

    const userDoc = await getDoc(doc(db, 'users', username));
    if (userDoc.exists() && userDoc.data().isBlocked) {
      alert("Has sido bloqueado por un moderador y no puedes enviar mensajes.");
      return;
    }

    if (newMessage.trim()) {
      const filteredMessage = filterMessage(newMessage);

      await addDoc(collection(db, 'messages'), {
        text: filteredMessage,
        username: username,
        avatarUrl: avatarUrl,
        timestamp: serverTimestamp(),
        role: role,
      });

      setNewMessage('');
      setDailyMessageCount(dailyMessageCount + 1);

      if (role === 'normal' && dailyMessageCount + 1 >= 50) {
        setIsChatDisabled(true);
        alert("Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.");
      }

      if (audioRef.current) {
        audioRef.current.play().catch((error) => {
          console.error("Error al reproducir el sonido: ", error);
        });
      }

      scrollToBottom();
    }
  };


  const handleImageUpload = async (e) => {
    if (isChatDisabled) {
      alert("Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.");
      return;
    }

    const file = e.target.files[0];
    if (file) {
      try {
        const imageRef = ref(storage, `chatImages/${username}-${Date.now()}`);
        await uploadBytes(imageRef, file);
        const imageUrl = await getDownloadURL(imageRef);

        await addDoc(collection(db, 'messages'), {
          imageUrl: imageUrl,
          username: username,
          avatarUrl: avatarUrl,
          timestamp: serverTimestamp(),
          role: role
        });

        setDailyMessageCount(dailyMessageCount + 1);

        if (role === 'normal' && dailyMessageCount + 1 >= 10) {
          setIsChatDisabled(true);
          alert("Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.");
        }

        scrollToBottom();
      } catch (error) {
        console.error("Error al subir la imagen: ", error);
      }
    }
  };

  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          const options = { mimeType: 'audio/webm' }; // Grabar en formato .webm
          const recorder = new MediaRecorder(stream, options);
          setMediaRecorder(recorder);
          recorder.start();
          setIsRecording(true);
  
          const audioChunks = [];
  
          recorder.ondataavailable = event => {
            audioChunks.push(event.data);
          };
  
          recorder.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
            const audioRef = ref(storage, `chatAudios/${username}-${Date.now()}.webm`); // Guardar como .webm inicialmente
            setIsSendingAudio(true);
  
            try {
              // Subir el archivo de audio en .webm al backend para conversión a .mp3
              await uploadBytes(audioRef, audioBlob);
              const audioUrl = await getDownloadURL(audioRef);
  
              await addDoc(collection(db, 'messages'), {
                audioUrl: audioUrl,
                username: username,
                avatarUrl: avatarUrl,
                timestamp: serverTimestamp(),
                role: role
              });
  
              setDailyMessageCount(dailyMessageCount + 1);
              if (role === 'normal' && dailyMessageCount + 1 >= 10) {
                setIsChatDisabled(true);
                alert("Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o inscribirte.");
              }
  
              scrollToBottom();
            } catch (error) {
              console.error("Error al enviar la nota de voz:", error);
              alert("Hubo un error al enviar la nota de voz. Por favor, intenta nuevamente.");
            } finally {
              setIsRecording(false);
              setIsSendingAudio(false);
            }
          };
        })
        .catch(error => {
          console.error("Error al acceder al micrófono:", error);
          alert("No se pudo acceder al micrófono. Por favor, revisa los permisos.");
        });
    } else {
      alert("Tu navegador no soporta la grabación de audio.");
    }
  };
  

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.stop();  
      setIsRecording(false);
    }
  };

  const handleAudioButtonClick = () => {
    if (isRecording) {
      stopRecording(); 
    } else {
      startRecording(); 
    }
  };

  const deleteMessage = async (messageId) => {
    try {
      await deleteDoc(doc(db, 'messages', messageId));
      alert("Mensaje eliminado correctamente.");
    } catch (error) {
      console.error("Error al eliminar el mensaje: ", error);
      alert("Hubo un error al intentar eliminar el mensaje.");
    }
  };

  const handleShareOnWhatsApp = () => {
    const message = encodeURIComponent("¡Únete a nuestro chat de Loterías! Aquí está el enlace: https://chatsrd.com/");
    const whatsappUrl = `https://api.whatsapp.com/send?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const getMessageStyle = (msgRole) => {
  switch (msgRole) {
    case 'oro':
      return {
        backgroundColor: '#FFD700', // Dorado brillante
        color: '#000', // Texto negro
        padding: '14px', // Espaciado interno mejorado
        borderRadius: '20px', // Bordes más redondeados
        maxWidth: '85%', // Ancho máximo
        boxShadow: '0px 4px 10px rgba(255, 215, 0, 0.5)', // Sombra dorada moderna
        border: '1px solid rgba(255, 193, 7, 0.6)', // Borde sutil
      };
    case 'platino':
      return {
        backgroundColor: '#B0E0E6', // Azul platino
        color: '#000', // Texto negro
        padding: '14px',
        borderRadius: '20px',
        maxWidth: '85%',
        boxShadow: '0px 4px 10px rgba(176, 224, 230, 0.7)', // Sombra azul clara
        border: '1px solid rgba(0, 0, 0, 0.3)', // Borde negro sutil
      };
    case 'moderador':
      return {
        backgroundColor: '#228B22', // Verde oscuro
        color: '#fff', // Texto blanco
        padding: '14px',
        borderRadius: '20px',
        maxWidth: '85%',
        boxShadow: '0px 4px 10px rgba(34, 139, 34, 0.5)', // Sombra verde
        border: '1px solid rgba(255, 255, 255, 0.5)', // Borde blanco suave
      };
    case 'normal':
    default:
      return {
        backgroundColor: msgRole === username ? '#3f51b5' : '#e0e0e0', // Azul o gris según el remitente
        color: msgRole === username ? '#fff' : '#000', // Texto blanco o negro
        padding: '14px',
        borderRadius: '15px',
        maxWidth: '85%',
        boxShadow: msgRole === username
          ? '0px 4px 10px rgba(63, 81, 181, 0.5)' // Sombra azul para el usuario
          : '0px 4px 10px rgba(0, 0, 0, 0.2)', // Sombra gris para otros
        border: msgRole === username
          ? '1px solid rgba(63, 81, 181, 0.6)' // Borde azul
          : '1px solid rgba(0, 0, 0, 0.2)', // Borde gris
      };
  }
};



const handlePredictionsClick = () => {
  // Solo permitir acceso a los roles 'oro' y 'platino'
  if (['oro', 'platino', 'moderador'].includes(role)) {
    setHasNewPrediction(false);
    navigate('/predictions');
  } else {
    // Mostrar alerta para roles no permitidos
    alert('🚫 Solo los miembros Oro y Platino tienen acceso a las predicciones. ¡Hazte miembro para acceder!');
  }
};

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
        <Box sx={{ flexGrow: 1, position: 'relative', borderRadius: '10px', boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)' }}>
        <IconButton
  component={Link}
  to="/settings"
  sx={{
    position: 'absolute',
    top: 10,
    right: 10,
    bgcolor: 'rgba(255, 255, 255, 0.1)', // Fondo translúcido
    borderRadius: '50%',
    padding: '10px',
    '&:hover': {
      bgcolor: 'rgba(255, 255, 255, 0.2)', // Hover más visible
    },
    transition: 'background-color 0.3s ease',
  }}
>
  <Settings sx={{ fontSize: '30px', color: 'white' }} /> {/* Ícono blanco */}
</IconButton>

          <Typography
  variant="h4"
  gutterBottom
  sx={{
    padding: '15px',
    background: 'linear-gradient(90deg, #3f51b5, #104dd0)',
    color: 'white',
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    fontWeight: 'bold',
    fontSize: '1.8rem',
  }}
  
>
  Bienvenido, {username}
</Typography>



<Box
  sx={{
    textAlign: 'center',
    mb: 2,
    display: 'flex', // Alinear horizontalmente
    flexWrap: 'wrap', // Permitir que los botones se ajusten en varias filas
    justifyContent: 'center', // Centrar los botones
    gap: 2, // Espaciado uniforme entre los botones
  }}
>

    <Box sx={{ mb: 2 }}>
      <AppBar position="static" >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          {/* Botón de menú para pantallas pequeñas */}
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ display: { xs: 'flex', md: 'none' } }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>

          {/* Título o logo */}
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
           Menu
          </Typography>

          {/* Botones de navegación para pantallas grandes */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            <Button
              variant="contained"
              startIcon={<PaymentIcon />}
              onClick={handleClick}
              sx={{
                backgroundColor: '#ff9800',
                color: 'white',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: '#f57c00',
                },
              }}
            >
              Recarga tu cuenta
            </Button>

            <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
              <MonetizationOnIcon sx={{ color: 'gold', mr: 1 }} />
              <Typography variant="body1" sx={{ color: 'white', fontWeight: 'bold' }}>
                {userCoins} Monedas
              </Typography>
            </Box>

            <Button color="inherit" component={Link} to="/historial-chat" startIcon={<HistoryIcon />}>
              Historial de Mensajes
            </Button>


            <Button color="inherit" component={Link} to="/ConnectedUsers" startIcon={<NotificationsNoneSharp />}>
              Usuarios en linea
            </Button>

            <Button color="inherit" onClick={handlePredictionsClick} startIcon={<NotificationsActiveIcon />}>
              Predicciones
            </Button>

            {/*<Button color="inherit" component={Link} to="/WeeklyStatistics" startIcon={<BarChartIcon />}>
              Estadísticas
            </Button>*/}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer para pantallas pequeñas */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
          <List>
            <ListItem button onClick={handleClick}>
              <ListItemIcon><PaymentIcon /></ListItemIcon>
              <ListItemText primary="Recarga tu cuenta" />
            </ListItem>

            <ListItem>
              <ListItemIcon><MonetizationOnIcon sx={{ color: 'gold' }} /></ListItemIcon>
              <ListItemText primary={`${userCoins} Monedas`} />
            </ListItem>

            <ListItem button component={Link} to="/historial-chat">
              <ListItemIcon><HistoryIcon /></ListItemIcon>
              <ListItemText primary="Historial de Mensajes" />
            </ListItem>
            

            <ListItem button onClick={handlePredictionsClick}>
              <ListItemIcon><NotificationsActiveIcon /></ListItemIcon>
              <ListItemText primary="Predicciones" />
            </ListItem>

            {/*<ListItem button component={Link} to="/WeeklyStatistics">
              <ListItemIcon><BarChartIcon /></ListItemIcon>
              <ListItemText primary="Estadísticas" />
            </ListItem>*/}

            <ListItem button component={Link} to="/ConnectedUsers">
              <ListItemIcon><NotificationsNoneSharp /></ListItemIcon>
              <ListItemText primary="Usuarios en Linea" />
            </ListItem>
            
          </List>
        </Box>
      </Drawer>
    </Box>
  


 {dailyNumbers.length > 0 && (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      mt: -2,
      mb: -2,
      flexWrap: 'wrap', // Por si se achica mucho el viewport
    }}
  >
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 700,
        color: '#745c00',
        fontSize: { xs: '1rem', sm: '1.09rem' },
        letterSpacing: 0.2,
        mr: 1,
        textTransform: 'uppercase',
      }}
    >
      Predicciones del día
    </Typography>
    <Box sx={{ display: 'flex', gap: 3.0 }}>
      {dailyNumbers.map((num, idx) => (
        <motion.div
          key={num}
          initial={{ scale: 0.65, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: idx * 0.09, type: 'spring', stiffness: 320 }}
          style={{
            background: 'linear-gradient(110deg, #ffe082 75%, #fff 100%)',
            color: '#6d4c01',
            fontWeight: 700,
            fontSize: '1.35rem',
            borderRadius: '10px',
            boxShadow: '0 2px 7px 0 #ffe08299',
            padding: '5px 18px',
            border: '2.5px solid #ffcc80',
            textShadow: '0 1px 2px #fff6',
            letterSpacing: '0.11em',
            minWidth: 36,
            textAlign: 'center',
          }}
        >
          {num}
        </motion.div>
      ))}
    </Box>
  </Box>
)}

  <motion.div
    animate={{
      opacity: [1, 0.5, 1],
    }}
    transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeInOut',
    }}
    style={{
      width: '100%', // Asegura el tamaño correcto al usar motion.div
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <Badge
      color="error"
      variant="dot"
      invisible={!hasNewPrediction}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      
    </Badge>
  </motion.div>

  <Box sx={{ position: 'fixed', top: 20, right: 20, zIndex: 1000 }}>
  {hasNewRecharge && (
    <Button
      variant="contained"
      color="success"
      onClick={() => {
        setHasNewRecharge(false);
        window.open('https://chatsrd.com/coin-history');
      }}
    >
      🎉 ¡Recibiste monedas! Haz clic para ver el historial
    </Button>
  )}
</Box>

</Box>
<Box sx={{ position: 'fixed', top: 20, right: 20, zIndex: 1000 }}>
  {hasNewRecharge && (
    <Button
      variant="contained"
      color="success"
      onClick={() => {
        setHasNewRecharge(false);
        window.open('https://chatsrd.com/coin-history', '_blank');
      }}
    >
      🎉 ¡Recibiste monedas! Haz clic para ver el historial
    </Button>
  )}
</Box>

          <Paper sx={{ p: 2, mb: 3, height: { xs: 'auto', md: '60vh' }, overflowY: 'auto', borderRadius: '10px', backgroundColor: '#f2f0ee' }}>
            {messages.map(({ id, data }) => (
              <motion.div 
                key={id} 
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', flexDirection: data.username === username ? 'row-reverse' : 'row' }}
              >
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.3 }}
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                  <Avatar src={data.avatarUrl} sx={{ ml: data.username === username ? 2 : 0, mr: data.username !== username ? 2 : 0 }} />

                  {data.role === 'moderador' && (
                    <Typography variant="caption" sx={{ color: 'green', fontSize: '0.74rem', textAlign: 'center', fontWeight: 'bold' }}>
                      Moderador
                    </Typography>
                  )}
                  {data.role === 'oro' && (
                    <Typography variant="caption" sx={{ color: 'gold', fontSize: '0.74rem', textAlign: 'center', fontWeight: 'bold' }}>
                      ORO
                    </Typography>
                  )}
                  {data.role === 'platino' && (
                    <Typography variant="caption" sx={{ color: 'lightblue', fontSize: '0.74rem', textAlign: 'center', fontWeight: 'bold' }}>
                      Platino
                    </Typography>
                  )}
                  {data.role === 'normal' && (
                    <Typography variant="caption" sx={{ color: 'black', fontSize: '0.74rem', textAlign: 'center', fontWeight: 'bold' }}>
                      Invitado
                    </Typography>
                  )}
                </motion.div>

                <Paper
  sx={{
    // Manualmente los estilos según el rol
     backgroundColor:
      data.role === 'oro'
        ? '#f3e7be'
        : data.role === 'platino'
        ? '#e3e8ee'
        : data.role === 'moderador'
        ? '#306844'
        : data.username === username
        ? '#1976d2'
        : '#fff',
    color:
      data.role === 'moderador'
        ? '#fff'
        : data.role === 'oro'
        ? '#745c00'
        : data.role === 'platino'
        ? '#183153'
        : data.username === username
        ? '#fff'
        : '#263238',
    border:
      data.role === 'oro'
        ? '1.5px solid #f5ca2d'
        : data.role === 'platino'
        ? '1.5px solid #81a4fd'
        : data.role === 'moderador'
        ? '1.5px solid #52b788'
        : data.username === username
        ? '1.5px solid #145ea8'
        : '1.5px solid #e0e0e0',
    boxShadow:
      data.role === 'oro'
        ? '0 2px 8px 0 rgba(245,202,45,0.08)'
        : data.role === 'platino'
        ? '0 2px 8px 0 rgba(129,164,253,0.08)'
        : data.role === 'moderador'
        ? '0 2px 8px 0 rgba(82,183,136,0.09)'
        : data.username === username
        ? '0 2px 8px 0 rgba(25,118,210,0.13)'
        : '0 2px 8px 0 rgba(0,0,0,0.06)',
    borderRadius: '17px',
    padding: '14px',
    maxWidth: '85%',
    textAlign: data.username === username ? 'right' : 'left',
    position: 'relative',
    marginLeft: data.username !== username ? '8px' : '0',
    marginRight: data.username === username ? '8px' : '0',
    fontWeight: data.role === 'moderador' ? 600 : 500,
    fontFamily: 'Segoe UI, Arial, sans-serif'
  }}
>
  <Typography variant="subtitle1">
    <strong>{data.role === 'platino' && '⭐'} {data.username}</strong>
  </Typography>
  {data.text && (
    <Typography variant="body1" dangerouslySetInnerHTML={{ __html: highlightKeyword(data.text) }} />
  )}
  {/* Miniatura de YouTube */}
  {data.text && renderYouTubeThumbnail(data.text)}

  {data.imageUrl && (
    <Box sx={{ mt: 2 }}>
      <img src={data.imageUrl} alt="Shared content" style={{ maxWidth: '100%', height: 'auto', maxHeight: '300px', borderRadius: '8px' }} />
    </Box>
  )}
  {data.audioUrl && (
    <Box sx={{ mt: 2 }}>
      <audio controls>
        <source src={data.audioUrl} type="audio/wav" />
        Your browser does not support the audio element.
      </audio>
    </Box>
  )}
 <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
  {data.timestamp && formatTimestamp(data.timestamp)}
</Typography>
  {role === 'moderador' && (
  <Tooltip title="Eliminar mensaje">
    <IconButton
      sx={{ position: 'absolute', top: 0, right: 0 }}
      onClick={() => deleteMessage(id)}
    >
      <DeleteIcon />
    </IconButton>
  </Tooltip>
)}
</Paper>

              </motion.div>
            ))}
            <div ref={messagesEndRef} />
          </Paper>

          {isChatDisabled && (
            <Box sx={{ mb: 3 }}>
              <Alert severity="warning">
              Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.
              </Alert>
            </Box>
          )}

          <Box 
  component="form" 
  onSubmit={sendMessage} 
  sx={{ 
    display: 'flex', 
    gap: 2, 
    padding: '10px', 
    backgroundColor: '#fff', 
    borderRadius: '0 0 10px 10px' 
  }}
>
  <TextField
    inputRef={inputRef}
    variant="outlined"
    margin="normal"
    fullWidth
    id="newMessage"
    label="Escribe un mensaje"
    name="newMessage"
    autoComplete="off"
    value={newMessage}
    onChange={(e) => setNewMessage(e.target.value)}
    disabled={isChatDisabled}
    sx={{ borderRadius: '10px', flexGrow: 1 }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <Button
            type="submit"
            variant="contained"
            sx={{ 
              borderRadius: '8px', 
              fontSize: '12px',
              padding: '4px 10px',
              minWidth: 'auto'
            }}
            disabled={isChatDisabled || newMessage.trim().length === 0}
          >
            Enviar
          </Button>
        </InputAdornment>
      )
    }}
  />

  <IconButton 
    color="primary" 
    component="label" 
    disabled={isChatDisabled}
  >
    <PhotoCamera />
    <input type="file" hidden onChange={handleImageUpload} />
  </IconButton>

  {['oro', 'platino', 'moderador'].includes(role) && (
    <>
      <IconButton 
        color="primary" 
        sx={{ fontSize: 37 }} 
        onClick={handleAudioButtonClick}
        disabled={isChatDisabled}
      >
        {isRecording ? <StopIcon fontSize="inherit" /> : <MicIcon fontSize="inherit" />}
      </IconButton>
      {isSendingAudio && <CircularProgress size={24} />} 
    </>
  )}
</Box>

          {role === 'normal' && showInfoMessage && (
            <Alert 
              severity="info" 
              sx={{ mt: 2, position: 'relative' }}
              action={
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => setShowInfoMessage(false)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              <AlertTitle>Información</AlertTitle>
              🟡 <strong>Hazte miembro y podrás tener acceso a los números recomendados y las mejores predicciones, el costo es de RD$1500 pesos.</strong>
            </Alert>
          )}

         <Box 
  sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    gap: 1, 
    mt: 2, 
    mb: 3, // margen inferior
    flexWrap: 'wrap' 
  }}
>
  <Button 
    variant="contained" 
    color="success" 
    startIcon={<ShareIcon />} 
    onClick={handleShareOnWhatsApp}
    sx={{ 
      fontSize: '12px', 
      px: 2, 
      py: 1, 
      borderRadius: '6px',
      minWidth: '160px'
    }}
  >
    WhatsApp
  </Button>
  <Button
    variant="contained"
    sx={{
      backgroundColor: '#f44336',
      color: '#fff',
      px: 2,
      py: 1,
      fontWeight: 'bold',
      borderRadius: '6px',
      fontSize: '12px',
      minWidth: '160px',
      '&:hover': { backgroundColor: '#d32f2f' },
    }}
    onClick={() => navigate('/InvestPage')}
  >
    Invierte y gana
  </Button>
</Box>


          <audio ref={audioRef} src="/sounds/notification.mp3" />
        </Box>
      </Box>

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '20px',
            maxWidth: '400px',
            margin: '100px auto',
            textAlign: 'center',
            position: 'relative',
          }}
        >
          <IconButton
            style={{ position: 'absolute', top: 10, right: 10 }}
            onClick={handleCloseModal}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" gutterBottom>
            ¡Comparte esta página!
          </Typography>
          <Typography variant="body1">
            Ayúdanos a crecer compartiendo este chat por WhatsApp para que más personas se unan.
          </Typography>

          <Button
            variant="contained"
            color="success"
            startIcon={<ShareIcon />}
            onClick={handleWhatsAppShare}
            style={{ marginTop: '20px' }}
          >
            Compartir en WhatsApp
          </Button>
          
        </motion.div>
      </Modal>
    </Container>

  );
}
export default Chat;